export default "__VITE_ASSET__D5TFeGRb__"